import React from "react";
import { i18nHMS } from "../../constants/function";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

export default function HMSTag({ duration, className }) {
  const { t } = useTranslation("common");
  const [time, setTime] = React.useState(null);

  React.useEffect(() => {
    const { hr, min, sec } = i18nHMS(duration);
    setTime(
      hr
        ? t("hr", { hr, min, sec })
        : min
        ? t("min", { min, sec })
        : sec
        ? t("sec", { sec })
        : ""
    );
  }, []);
  return (
    <Typography
      className={className}
      variant="body2"
      sx={{ color: "#FFFFFFCC" }}
    >
      {time}
    </Typography>
  );
}
